// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid div {
    background-color: #181b25;
    color: white;
}

.offcanvas-title div {
    width: 100%;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.container-fluid img {
    height: 50px;
}

.offcanvas-body {
    width: 100%;
    overflow-y: auto; /* Permitir scroll vertical */
    flex: 1; /* Tomar todo el espacio disponible */
}

.offcanvas-body p {
    width: 100%;
    /* text-align: center; */
    padding: 10px 0;
    margin-bottom: 0;
    font-size: 18px;
    /* border-bottom: 1px solid rgba(128, 128, 128, 0.483); */
}

.closeMenuMov {
    width: 90%;
    margin: 20px 5%;
    padding: 8px;
    color: white;
    font-size: 1rem !important;
}

.offcanvas-body i {
    display: inline-block;
    margin-right: 8px;
}

.activo {
    color: #f09502;
}

/* Ensure the navbar toggle button stays visible */
.navbar-toggler {
    z-index: 1051; /* Ensure the toggle button stays above the off-canvas */
    position: relative; /* Keep its position relative to allow for visibility */
}

.navbar-movil{
    /* background-color: #181b25 !important;  */
    padding: 1rem;
    border: 2px solid #f09502;
    border-radius: 15px;
    height: 100%;
    overflow-y: auto; /* Permitir scroll vertical */
    max-height: 100vh; /* Altura máxima */
    display: flex;
    flex-direction: column;
}

.loading-text {
    animation: fade 1.25s infinite;
  }

.add-funds{
    padding: 0 !important;
    width: 45px !important;
    cursor: pointer;
}

.balance-text{
    font-size: 1.75rem !important;
}

.loading-text{
    font-size: 1.75rem !important;
}

/* Estilos específicos para iPad y arreglar el backdrop */
@media only screen 
and (min-device-width: 768px) 
and (max-device-width: 1024px) {
    /* Mayor opacidad para el backdrop en tablets */
    .offcanvas-backdrop.show {
        opacity: 0.8;
    }
    
    /* Asegurar que el offcanvas está por encima */
    .offcanvas.show {
        z-index: 1050;
    }
}

/* Media queries for responsiveness */
@media (max-width: 1366px) {
    .add-funds {
        width: 30px !important;
    }
    .balance-text, .loading-text {
        font-size: 1.2rem !important;
    }
}

@media (max-width: 1200px) {
    .add-funds {
        width: 25px !important;
    }
    .balance-text, .loading-text {
        font-size: 1rem !important;
    }
}

@media (max-width: 992px) {
    .add-funds {
        width: 20px !important;
    }
    .balance-text, .loading-text {
        font-size: 0.875rem !important;
    }
}

@media (max-width: 768px) {
    .add-funds {
        width: 15px !important;
    }
    .balance-text, .loading-text {
        font-size: 0.75rem !important;
    }
}

@media (max-width: 576px) {
    .add-funds {
        width: 30px !important;
    }
    .balance-text, .loading-text {
        font-size: 1.5rem !important;
    }
}

.padding-p-collapse {
    margin-bottom: 4px !important;
    padding-bottom: 0 !important;
}

.padding-p-collapse a{
    color: white;
    text-decoration: none;
}

.chevron-icon {
    transition: transform 0.3s ease !important;
}

.chevron-icon.rotate {
    transform: rotate(180deg) !important;
}

.sub-option p{
    padding: 4px 0;
    margin-bottom: 0;
    font-size: 14px;
}

/* Override global card-body padding for menu submenus */
.offcanvas-body .card-body {
    padding: 0 !important;
    padding-left: 1.1vw !important; /* Restore left margin for submenus */
}

.offcanvas-body .sub-option {
    padding: 0 !important;
    padding-left: 1.1vw !important; /* Restore left margin for submenus */
}

.divider {
    position: relative;
    width: 100% !important;
    height: 1px;
    background-color: white !important;
    padding: 0 !important;
}

/* Estilos para el contenedor principal del offcanvas */
.offcanvas {
    overflow-y: hidden; /* Evitar scroll en el offcanvas en sí */
}

/* Espacio adicional al final para evitar que el contenido se corte */
.offcanvas-body:after {
    content: "";
    display: block;
    height: 80px; /* Espacio al final para dispositivos pequeños */
}

/* Ajustes específicos para dispositivos muy pequeños */
@media (max-height: 700px) {
    .navbar-movil {
        padding-bottom: 60px; /* Espacio adicional para asegurar visibilidad del botón de cerrar */
    }
    
    .closeMenuMov {
        position: fixed !important; /* Fijar en la parte inferior */
        bottom: 10px !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        width: 80% !important;
        z-index: 1060 !important; /* Asegurar que esté sobre otros elementos */
    }
}

.menu-mobile-nav {
  position: fixed;
  top:0;
  left:0;
  right:0;
  z-index:1045;          /* igual o mayor a lo que tenías */
  background: transparent !important; /* lo pinta el ::before */
}

/* Capa de fondo que cubre todo el ancho (no depende del ancho del logo/contenido) */
.menu-mobile-nav::before {
  content:"";
  position:absolute;
  inset:0;
  background:#181b25;
  pointer-events:none;
  z-index:0;
}

/* Asegura que el contenido quede encima del fondo */
.menu-mobile-nav > * {
  position:relative;
  z-index:1;
}

/* Evita que container-fluid genere otro bloque distinto */
.menu-mobile-nav .container-fluid {
  background:transparent !important;
  padding-left:8px;
  padding-right:8px;
}

/* Botón hamburguesa conservando su estilo actual */
.menu-mobile-nav .navbar-toggler {
  z-index:2;
}

/* Hacer el menú hamburguesa un poco más pequeño en móvil */
@media (max-width: 768px) {
  .menu-mobile-nav .navbar-toggler {
    width: 44px;
    height: 44px;
    padding: 0.45rem;
    font-size: 1.05rem;
    margin-left: 4px;
  }
  
  .menu-mobile-nav .navbar-toggler-icon {
    width: 1.5em;
    height: 1.5em;
  }
}

/* Ajuste para pantallas pequeñas */
@media (max-width: 480px) {
  .menu-mobile-nav .navbar-toggler {
    width: 42px;
    height: 42px;
    padding: 0.45rem;
    font-size: 1rem;
    margin-left: 4px;
  }
  
  .menu-mobile-nav .navbar-toggler-icon {
    width: 1.4em;
    height: 1.4em;
  }
}

/* (Opcional) cuerpo global oscuro si el blanco del body se sigue notando al hacer scroll inicial */
body {
  background:#181b25;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-movil/menu-movil.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB,EAAE,6BAA6B;IAC/C,OAAO,EAAE,qCAAqC;AAClD;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yDAAyD;AAC7D;;AAEA;IACI,UAAU;IACV,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI,aAAa,EAAE,wDAAwD;IACvE,kBAAkB,EAAE,uDAAuD;AAC/E;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB,EAAE,6BAA6B;IAC/C,iBAAiB,EAAE,kBAAkB;IACrC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;EAChC;;AAEF;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA,yDAAyD;AACzD;;;IAGI,+CAA+C;IAC/C;QACI,YAAY;IAChB;;IAEA,8CAA8C;IAC9C;QACI,aAAa;IACjB;AACJ;;AAEA,qCAAqC;AACrC;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,wDAAwD;AACxD;IACI,qBAAqB;IACrB,8BAA8B,EAAE,qCAAqC;AACzE;;AAEA;IACI,qBAAqB;IACrB,8BAA8B,EAAE,qCAAqC;AACzE;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA,uDAAuD;AACvD;IACI,kBAAkB,EAAE,wCAAwC;AAChE;;AAEA,qEAAqE;AACrE;IACI,WAAW;IACX,cAAc;IACd,YAAY,EAAE,gDAAgD;AAClE;;AAEA,uDAAuD;AACvD;IACI;QACI,oBAAoB,EAAE,oEAAoE;IAC9F;;IAEA;QACI,0BAA0B,EAAE,+BAA+B;QAC3D,uBAAuB;QACvB,oBAAoB;QACpB,sCAAsC;QACtC,qBAAqB;QACrB,wBAAwB,EAAE,4CAA4C;IAC1E;AACJ;;AAEA;EACE,eAAe;EACf,KAAK;EACL,MAAM;EACN,OAAO;EACP,YAAY,WAAW,kCAAkC;EACzD,kCAAkC,EAAE,yBAAyB;AAC/D;;AAEA,oFAAoF;AACpF;EACE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA,0DAA0D;AAC1D;EACE,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA,mGAAmG;AACnG;EACE,kBAAkB;AACpB","sourcesContent":[".container-fluid div {\n    background-color: #181b25;\n    color: white;\n}\n\n.offcanvas-title div {\n    width: 100%;\n    padding: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.container-fluid img {\n    height: 50px;\n}\n\n.offcanvas-body {\n    width: 100%;\n    overflow-y: auto; /* Permitir scroll vertical */\n    flex: 1; /* Tomar todo el espacio disponible */\n}\n\n.offcanvas-body p {\n    width: 100%;\n    /* text-align: center; */\n    padding: 10px 0;\n    margin-bottom: 0;\n    font-size: 18px;\n    /* border-bottom: 1px solid rgba(128, 128, 128, 0.483); */\n}\n\n.closeMenuMov {\n    width: 90%;\n    margin: 20px 5%;\n    padding: 8px;\n    color: white;\n    font-size: 1rem !important;\n}\n\n.offcanvas-body i {\n    display: inline-block;\n    margin-right: 8px;\n}\n\n.activo {\n    color: #f09502;\n}\n\n/* Ensure the navbar toggle button stays visible */\n.navbar-toggler {\n    z-index: 1051; /* Ensure the toggle button stays above the off-canvas */\n    position: relative; /* Keep its position relative to allow for visibility */\n}\n\n.navbar-movil{\n    /* background-color: #181b25 !important;  */\n    padding: 1rem;\n    border: 2px solid #f09502;\n    border-radius: 15px;\n    height: 100%;\n    overflow-y: auto; /* Permitir scroll vertical */\n    max-height: 100vh; /* Altura máxima */\n    display: flex;\n    flex-direction: column;\n}\n\n.loading-text {\n    animation: fade 1.25s infinite;\n  }\n\n.add-funds{\n    padding: 0 !important;\n    width: 45px !important;\n    cursor: pointer;\n}\n\n.balance-text{\n    font-size: 1.75rem !important;\n}\n\n.loading-text{\n    font-size: 1.75rem !important;\n}\n\n/* Estilos específicos para iPad y arreglar el backdrop */\n@media only screen \nand (min-device-width: 768px) \nand (max-device-width: 1024px) {\n    /* Mayor opacidad para el backdrop en tablets */\n    .offcanvas-backdrop.show {\n        opacity: 0.8;\n    }\n    \n    /* Asegurar que el offcanvas está por encima */\n    .offcanvas.show {\n        z-index: 1050;\n    }\n}\n\n/* Media queries for responsiveness */\n@media (max-width: 1366px) {\n    .add-funds {\n        width: 30px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 1.2rem !important;\n    }\n}\n\n@media (max-width: 1200px) {\n    .add-funds {\n        width: 25px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 1rem !important;\n    }\n}\n\n@media (max-width: 992px) {\n    .add-funds {\n        width: 20px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 0.875rem !important;\n    }\n}\n\n@media (max-width: 768px) {\n    .add-funds {\n        width: 15px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 0.75rem !important;\n    }\n}\n\n@media (max-width: 576px) {\n    .add-funds {\n        width: 30px !important;\n    }\n    .balance-text, .loading-text {\n        font-size: 1.5rem !important;\n    }\n}\n\n.padding-p-collapse {\n    margin-bottom: 4px !important;\n    padding-bottom: 0 !important;\n}\n\n.padding-p-collapse a{\n    color: white;\n    text-decoration: none;\n}\n\n.chevron-icon {\n    transition: transform 0.3s ease !important;\n}\n\n.chevron-icon.rotate {\n    transform: rotate(180deg) !important;\n}\n\n.sub-option p{\n    padding: 4px 0;\n    margin-bottom: 0;\n    font-size: 14px;\n}\n\n/* Override global card-body padding for menu submenus */\n.offcanvas-body .card-body {\n    padding: 0 !important;\n    padding-left: 1.1vw !important; /* Restore left margin for submenus */\n}\n\n.offcanvas-body .sub-option {\n    padding: 0 !important;\n    padding-left: 1.1vw !important; /* Restore left margin for submenus */\n}\n\n.divider {\n    position: relative;\n    width: 100% !important;\n    height: 1px;\n    background-color: white !important;\n    padding: 0 !important;\n}\n\n/* Estilos para el contenedor principal del offcanvas */\n.offcanvas {\n    overflow-y: hidden; /* Evitar scroll en el offcanvas en sí */\n}\n\n/* Espacio adicional al final para evitar que el contenido se corte */\n.offcanvas-body:after {\n    content: \"\";\n    display: block;\n    height: 80px; /* Espacio al final para dispositivos pequeños */\n}\n\n/* Ajustes específicos para dispositivos muy pequeños */\n@media (max-height: 700px) {\n    .navbar-movil {\n        padding-bottom: 60px; /* Espacio adicional para asegurar visibilidad del botón de cerrar */\n    }\n    \n    .closeMenuMov {\n        position: fixed !important; /* Fijar en la parte inferior */\n        bottom: 10px !important;\n        left: 50% !important;\n        transform: translateX(-50%) !important;\n        width: 80% !important;\n        z-index: 1060 !important; /* Asegurar que esté sobre otros elementos */\n    }\n}\n\n.menu-mobile-nav {\n  position: fixed;\n  top:0;\n  left:0;\n  right:0;\n  z-index:1045;          /* igual o mayor a lo que tenías */\n  background: transparent !important; /* lo pinta el ::before */\n}\n\n/* Capa de fondo que cubre todo el ancho (no depende del ancho del logo/contenido) */\n.menu-mobile-nav::before {\n  content:\"\";\n  position:absolute;\n  inset:0;\n  background:#181b25;\n  pointer-events:none;\n  z-index:0;\n}\n\n/* Asegura que el contenido quede encima del fondo */\n.menu-mobile-nav > * {\n  position:relative;\n  z-index:1;\n}\n\n/* Evita que container-fluid genere otro bloque distinto */\n.menu-mobile-nav .container-fluid {\n  background:transparent !important;\n  padding-left:8px;\n  padding-right:8px;\n}\n\n/* Botón hamburguesa conservando su estilo actual */\n.menu-mobile-nav .navbar-toggler {\n  z-index:2;\n}\n\n/* Hacer el menú hamburguesa un poco más pequeño en móvil */\n@media (max-width: 768px) {\n  .menu-mobile-nav .navbar-toggler {\n    width: 44px;\n    height: 44px;\n    padding: 0.45rem;\n    font-size: 1.05rem;\n    margin-left: 4px;\n  }\n  \n  .menu-mobile-nav .navbar-toggler-icon {\n    width: 1.5em;\n    height: 1.5em;\n  }\n}\n\n/* Ajuste para pantallas pequeñas */\n@media (max-width: 480px) {\n  .menu-mobile-nav .navbar-toggler {\n    width: 42px;\n    height: 42px;\n    padding: 0.45rem;\n    font-size: 1rem;\n    margin-left: 4px;\n  }\n  \n  .menu-mobile-nav .navbar-toggler-icon {\n    width: 1.4em;\n    height: 1.4em;\n  }\n}\n\n/* (Opcional) cuerpo global oscuro si el blanco del body se sigue notando al hacer scroll inicial */\nbody {\n  background:#181b25;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
